"use client";
import { useRouter } from "next/navigation";
import ReviewDetailPage from "@/components/pages/ReviewDetailPage";
import DetailBreadcrumb, { type DetailBreadcrumbItem } from "@/components/seo/DetailBreadcrumb";

interface Props {
  review: any; // type khớp với return của getReviewBySlugOrId
}

export default function ReviewDetailClient({ review }: Props) {
  const router = useRouter();

  const breadcrumbs: DetailBreadcrumbItem[] = [
    { label: "Review", href: "/reviews" },
    { label: review.title ?? "Bài đánh giá" },
  ];

  return (
    <div>
      <div className="max-w-[800px] mx-auto px-4 pt-6">
        <DetailBreadcrumb items={breadcrumbs} />
      </div>

      <ReviewDetailPage
        initialReview={review}
        onBack={() => {
          if (window.history.length > 1) router.back();
          else router.push("/reviews");
        }}
        onNavigate={(page) => {
          if (page.startsWith("path-detail:")) router.push("/paths/" + page.split(":")[1]);
          else if (page.startsWith("exam-detail:")) router.push("/exams/" + page.split(":")[1]);
          else if (page.startsWith("review-detail:")) router.push("/reviews/" + page.split(":")[1]);
          else router.push("/" + page);
        }}
      />
    </div>
  );
}